export const API_COMPANY_ID = 'UNITYCRM0021';
export const API_BASE_URL = 'https://prepaid-api.aqsatel.com/api';
export const API_QR_CODE_URL = 'https://api.aqsatel.com/showImage/qrcodes';
export const API_ENDPOINTS = {
  IMEI_CHECK: '/Pre-paid/GetDeviceCompatibility',
  ACTIVATION_BEGIN: '/Pre-paid/ValidateCode',
  ACTIVATION_NETWORKS: '/Pre-paid/GetNetworks',
  ACTIVATION_COMPATIBILITY: '/Pre-paid/GetDeviceCompatibility',
  ACTIVATION_NEW: '/Pre-paid/OrderActivation',
  ACTIVATION_TRANSFER: '/Pre-paid/OrderPortIn',
  ACTIVATION_TRANSFER_STATUS: '/Pre-paid/GetPortInDetail',
  ACTIVATION_TRANSFER_UPDATE: '/Pre-paid/OrderPortInUpdate',
  ACTIVATION_TRANSFER_DELETE: '/MyAccount/PortIn',
  ACTIVATION_ACCOUNT: '/Pre-paid/StoreAccountInfo',
  ACTIVATION_PASSWORD: '/Pre-paid/AccountPassword',
  ACTIVATION_INSTALL: '/Pre-paid/SimDelivery',
  ACTIVATION_RESET: '/Pre-paid/ResetActivation',
  ACTIVATION_CREATE_SUBSCRIPTION: '/Customer/AddPrepaidCustomer',
  ACTIVATION_AUTHORIZATION: '/transactions/cardAuthorization',
  VALIDATE_USERNAME: '/unity/userNameVerify',
  ENCRYPT: '/Pre-paid/GetEncrypt',

};
export const ACTIVATION_API_URL = 'https://t69s3qnfud.execute-api.us-east-1.amazonaws.com/dev/activation-v2';
export const DISCOUNT_API_URL = 'https://t69s3qnfud.execute-api.us-east-1.amazonaws.com/dev/discount-details';
export const PRIVATE_API_BASE_URL = 'https://t69s3qnfud.execute-api.us-east-1.amazonaws.com/dev';
export const PRIVATE_API_ENDPOINTS = {
  ACTIVATION_RULES: '/activation-rules',
};
